import * as React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import LocationWorkAreas from 'modules/locations/components/WorkAreas'
import { useWorkAreas } from 'modules/locations/hooks/useWorkAreas'
import type Location from 'modules/locations/store/models/Location'

const WorkAreasComponent = ({ children }: React.PropsWithChildren<{}>) => {
  const { location } = useOutletContext<{ location: Location }>()

  const locationId = location.id

  const { navigation } = useNavigation()
  const { workAreas, loading, error } = useWorkAreas({
    locationIds: [locationId],
  })
  const unArchivedWorkAreas = workAreas.filter((workArea) => !workArea.archivedAt)
  const archivedWorkAreas = workAreas.filter((workArea) => workArea.archivedAt)
  const navigate = useNavigate()

  const addWorkArea = () => {
    track(trackingEvents.spaceControl.addWorkArea)
    navigate(navigation.settings.locations.locationsId.workAreas.add.fullPath({ id: locationId }))
  }
  const canManageWorkArea = users.current.policy.can('locations.workAreaManage')

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={error}
      widget={
        canManageWorkArea && (
          <Button onClick={addWorkArea}>
            {i18n.t('settings.locations.location.work_areas.add.button')}
          </Button>
        )
      }
    >
      {children}
      <LocationWorkAreas
        locationId={location.id}
        archivedWorkAreas={archivedWorkAreas}
        unArchivedWorkAreas={unArchivedWorkAreas}
      />
    </ResponsivePage.Body>
  )
}

export default WorkAreasComponent
